import styled from '@emotion/styled'

import media from '../../../styles/media'
import { colors } from '../../../styles/theme'

const S = {}

S.Arrow = styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 10;
  top: 50%;
  width: var(--arrow-offset);
  height: var(--arrow-offset);
  transform: translateY(calc(-50% - 1.1875rem));
  transition: 0.15s ease;
  transition-property: background-color, color;

  ${media.sm`
    transform: translateY(calc(-50% - 0.6875rem));
  `};

  ${media.md`
    transform: translateY(-50%);
  `};

  @media (hover: hover) {
    ${colors.shark};
  }

  &:focus {
    background-color: ${colors.shark};
    box-shadow: 0 0 0 0.25rem ${colors.silverChalice} inset;
    outline: 0.125rem solid transparent;
    outline-offset: 0.125rem;
  }

  svg {
    fill: currentColor;
    color: white;
    height: 100%;
    width: 100%;
  }

  &.slick-prev {
    inset-inline-start: 0;
  }

  &.slick-next {
    inset-inline-end: 0;
  }
`

export default S
